import { Config, IS_ELECTRON, IS_DEV } from './config'
import { getCookieToken } from './cookie'
import { getUserToken as getUserTokenByElectron } from './electron'

const initToken = () => {
  if (IS_ELECTRON) {
    return getUserTokenByElectron()
  }

  const cookieToken = getCookieToken()

  if (!IS_DEV || cookieToken) {
    return cookieToken
  }

  return Config.testToken
}

const token = initToken()

const getUserToken = () => {
  return token
}

export enum EUserMemberType {
  'Free' = 'Free',
  'Lite' = 'Lite',
  'Basic' = 'Basic',
  'Premium' = 'Premium',
  'Business' = 'Business',
  'Business Pro' = 'Business Pro',
  'Enterprise' = 'Enterprise',
  'Enterprise Pro' = 'Enterprise Pro',
}

/* 每一页数的价格 */
export const pagePrice = {
  [EUserMemberType.Free]: 30,
  [EUserMemberType.Lite]: 20,
  [EUserMemberType.Basic]: 10,
  [EUserMemberType.Premium]: 8,
  [EUserMemberType.Business]: 6,
  [EUserMemberType['Business Pro']]: 5,
  [EUserMemberType.Enterprise]: 5,
  [EUserMemberType['Enterprise Pro']]: 5,
}

export { getUserToken }
